/* istanbul ignore file */
import { Badge } from 'framework/ui/mui-builder';
import { FieldBadgeProps } from 'framework/ui/ui-builder';

const PotentialCandidateBadge = (props: FieldBadgeProps) => {
  return (
    <Badge color="secondary" sx={{ ml: 1 }} {...props}>
      KIV
    </Badge>
  );
};

export default PotentialCandidateBadge;
